module.exports = __webpack_public_path__ + "img/search_box.062486c0.png";